const MOBILE_BREAKPOINT = 768

export default {
  data () {
    return {
      viewportWidth: typeof window === 'undefined' ? 1200 : window.innerWidth
    }
  },
  computed: {
    isCompactViewport () {
      return this.viewportWidth <= MOBILE_BREAKPOINT
    }
  },
  mounted () {
    this._responsiveTableResize = () => {
      this.viewportWidth = window.innerWidth
    }
    window.addEventListener('resize', this._responsiveTableResize)
  },
  beforeDestroy () {
    if (this._responsiveTableResize) {
      window.removeEventListener('resize', this._responsiveTableResize)
    }
  }
}
